<template>
  <div v-if="componentReady" class="createmastercourses">
    <div class="content">

      <Disclaimer v-if="info.status === 'PUBLISHED'" />

      <!-- PASO 2  -->

      <div class="info">

        <h1>{{ $t('informationMasterCourses.CONFIGURATION') }}</h1>
        <h3>{{ $t('informationMasterCourses.STEP_NUMBER', { number: 2 }) }}</h3>
        <h5>{{ $t('informationMasterCourses.COURSE_INFORMATION') }}</h5>

        <Input 
          type="textarea" 
          id="coursedescription" 
          :label="$t('informationMasterCourses.COURSE_DESCRIPTION')" 
          :maxlength="500"
          :placeholder="$t('informationMasterCourses.COURSE_DESCRIPTION_PLACEHOLDER')" 
          v-model="info.description"
          :isError="v$.info.description.required.$invalid && submitted"
          :errorMessage="$t('global.FIELD_REQUIRED')" />

        <!-- <Input 
          type="textarea"
          id="requeriments"
          label="REQUISITOS"
          :maxlength="500"
          placeholder="Para realizar este curso necestiarás..."
          v-model="info.requeriments"
          :isError="v$.info.requeriments.required.$invalid && submitted"
          errorMessage="Este campo es requerido"
        /> -->

        <Select 
          mode="simple" 
          id="modality" 
          :label="$t('informationMasterCourses.MODALITY')" 
          :values="creationOptions.modalities" 
          valueLabel="name"
          valueProp="id" 
          v-model="info.modalityId" 
          :isError="v$.info.modalityId.required.$invalid && submitted"
          :errorMessage="$t('global.FIELD_REQUIRED')" 
        />

        <Input 
          type="number"
          :label="$t('informationMasterCourses.TOTAL_DURATION_WEEKS')" 
          v-model="info.weekDuration"
          :isError="v$.info.weekDuration.required.$invalid && submitted" 
          :errorMessage="$t('global.FIELD_REQUIRED')" 
          :labelNextToNumber="$t('informationMasterCourses.WEEKS')"
          />

        <Input 
          type="number" 
          :label="$t('informationMasterCourses.WEEKLY_HOURS_DEDICATION')" 
          id="dedication" 
          v-model="info.hourDedication"
          :isError="v$.info.hourDedication.required.$invalid && submitted" 
          :errorMessage="$t('global.FIELD_REQUIRED')" 
          :labelNextToNumber="$t('informationMasterCourses.HOURS')"
          />

        <!-- input tutorial string-->
        <Input 
          type="text" 
          id="tutorial" 
          :label="$t('informationMasterCourses.TUTORIAL')" 
          placeholder="https://www.youtube.com/watch?v=..."
          v-model="info.tutorial"
        />
      </div>
      


      <div class="buttons">
        <button @click="router.push('edit')" class="button__backward"><i class="material-icons-outlined">arrow_back</i>
          {{ $t('global.BACK') }}</button>
        <button :disabled="submitting" @click="submitStep" class="button__forward">{{ $t('global.CONTINUE') }}<i
            class="material-icons-outlined">arrow_forward</i></button>
      </div>
    </div>

  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Inputs/Select.vue';
import { useRouter } from 'vue-router';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useStore } from 'vuex';
import Disclaimer from '@/views/Contents/MastersCourses/Disclaimer.vue';
import { useI18n } from 'vue-i18n';


export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    creationOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Input,
    Select,
    Disclaimer
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const v$ = useVuelidate()
    const submitted = ref(false)
    const submitting = ref(false)
    const componentReady = ref(false)
    const info2_invalid = computed(() => v$.value.info.description.$invalid || v$.value.info.modalityId.$invalid || v$.value.info.weekDuration.$invalid || v$.value.info.hourDedication.$invalid);

    const { t } = useI18n();

    const info = ref()

    const submitStep = async () => {
      if(submitting.value) return
      submitted.value = true
      if (info2_invalid.value) return
      try {
        submitting.value = true
        await store.dispatch('courses_cfgsecondStep', info.value)
        router.push(`structure`)
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('informationMasterCourses.ERROR_SENDING_DATA') })
      } finally {
        submitting.value = false
      }
    }

    onMounted(() => {
      info.value = props.data
      componentReady.value = true
    })

    return {
      router,
      info,
      v$,
      submitted,
      componentReady,
      submitting,
      t,

      submitStep
    }
  },
  validations() {
    return {
      info: {
        description: { required },
        // requeriments: { required },
        modalityId: { required },
        weekDuration: { required },
        hourDedication: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;

  .button {
    text-align: center;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 999px;
    padding: 12px 18px;

    &__forward {
      @extend .button;
      color: #fff;
      background-color: $green;
      &:disabled{
        cursor: default;
        opacity: .6;
      }
    }

    &__backward {
      @extend .button;
      border: 1px solid $green;
      color: $green;
      background-color: inherit;
    }
  }
}

.goBack {
  color: $green;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  .material-icons-outlined {
    font-size: 18px;
  }
}

.content {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  padding: 32px 0;
}

.info {
  display: flex;
  flex-direction: column;
  max-width: 370px;
  width: 100%;
  margin: 0 auto;
  gap: 18px;
  align-items: center;

  h1 {
    font-size: 24px;
    font-weight: 800;
  }

  h3 {
    font-size: 14px;
    font-weight: 800;
  }

  h5 {
    font-size: 20px;
    font-weight: 600;
  }
}

.step {
  &1__uploadFile {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;
    align-items: center;
    padding: 27px 0;
    border-radius: 10px;
    font-size: 12px;

    &--required {
      @extend .step1__uploadFile;
      border: 1px solid #F57055;
    }

    .material-icons-outlined {
      padding: 12px;
      border-radius: 99px;
      color: #fff;
      background-color: $green;
      margin-bottom: 12px;
    }

    label {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $green;
      cursor: pointer;
      font-weight: 600;
      margin-bottom: 12px;

      input {
        display: none;
      }
    }
  }

  &1__fileUploaded {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 26px 28px;
    background-color: #F6F6F6;
    width: 100%;

    &_data {
      display: flex;
      align-items: flex-start;
      gap: 12px;

      .material-icons-outlined:first-child {
        font-size: 28px;
      }
    }

    &_file {
      display: flex;
      flex-direction: column;
      gap: 6px;

      strong {
        font-size: 16px;
        font-weight: 600;
        color: $green;
      }

      font-size: 16px;
      font-weight: 400;
    }

    .material-icons-outlined:last-child {
      cursor: pointer;
    }
  }
}

.header-steps {
  width: 100%;
  margin-bottom: 32px;
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 42px;
  border-bottom: 1px solid #D9D9D9;
  background: #fff;

  .step {
    @include icon-and-text-container;

    span:first-child {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      height: 28px;
      border-radius: 100%;
      background: #BDBDBD;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      line-height: 28px;
    }

    span:last-child {
      font-size: 13px;
      font-weight: 600;
      color: #BDBDBD;
    }

    &--selected {
      span:first-child {
        background: #FFB23F;
        color: #212121;
      }

      span:last-child {
        color: #212121;
      }
    }

    .material-icons {
      color: #77C991;
      font-size: 29px
    }

    @media screen and (max-width: 800px) {
      display: none;

      &.step--selected {
        display: flex;
      }
    }
  }
}
</style>